import BaseResource from './BaseResource';

export default class QuoteItemResource extends BaseResource {
  constructor(url) {
    super({ url });
  }

  create(variantId) {
    return super
      .post({}, { url: `${this.url}/${variantId}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  delete(itemId) {
    return super
      .delete({ url: `${this.url}/${itemId}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  paid(itemId, paid) {
    return super
      .put({}, { url: `${this.url}/${itemId}/payment/${paid}` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
